import Base from "./Base";
import MapCommon from "../../common/MapCommon";
import SelectPolygon from "./SelectPolygon";
import {TOOL_MERGE} from "./ToolType";

export default class MergeTool extends Base{
  constructor(options = {}) {
    let params={
      map:null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-hebing",//图标类名
      callBackName: "",//正常地图事件回调
      errorEventName: "",//错误地图事件回调
      chineseName: "合并",//中文工具名称
      checkValid:false,//是否检测自相交
      callBack:null,
      errorCallBack:null,
      clickLayers:[],//点选目标图层id
      features:[],//需要展示到点选图层的要素
      clickLayersFilters:[],//点击图层过滤器
      stopLayers:[],//遮挡图层id
    }
    Object.assign(params,options)
    super(params.map, TOOL_MERGE, params);
    this.checkValid=params.checkValid;
    this.clickLayersFilters=params.clickLayersFilters;
    this.stopLayers=params.stopLayers;
    this.params=params;

  }

  start(){
    super.start();
    if(this.params.features&&this.params.features.length>1){//已有多边形，直接绘制然后分割
      this._startMerge();
    }else {
      this.params.features=[];
      this._setFinishEvent();
      this._startSelectPolygon();
    }
    //关闭双击缩放
    this._doubleClickZoom=this.map.doubleClickZoom.isEnabled()
    if(this._doubleClickZoom){
      this.map.doubleClickZoom.disable();
    }
  }
  _setFinishEvent(){
    this._finishEvent=()=>{
      if(this.params.features.length>1){
        this._startMerge();
      }
    }

    this.map.on("contextmenu", this._finishEvent);
    this.map.on("dblclick", this._finishEvent);
  }
  _startSelectPolygon(){
    //需要点选的情况，增加点选图层
    this.selectControl=new SelectPolygon({
      map:this.map,
      continueSelect:true,
      clickLayers:this.params.clickLayers,
      showIcon:false,
      clickLayersFilters:this.params.clickLayersFilters,//点击图层过滤器
      stopLayers:this.params.stopLayers,//遮挡图层id
      callBack:(res)=>{
        this.params.features=res.features;
        this.curPolygon=res.features[0];
      }
    });
    this.selectControl.start();
  }


  _startMerge(){
    let res=MapCommon.unionPolygons(this.params.features);
    console.log("合并结果",res)
    if(this.selectControl){
      this.selectControl.close();
      this.selectControl=null;
    }
    if(res.msg){
      this.error(res.msg);
    }else {
      this.finish(res.polygon)
    }
  }

  close(notClearMap=false) {
    this.clear(notClearMap);
    this.clearEvent();
  }

  clear(notClearMap=false) {
    //移除线绘制
    if(this.drawLineControl){
      this.drawLineControl.close();
      this.drawLineControl=null;
    }
    if(this.selectControl){
      this.selectControl.close();
      this.selectControl=null;
    }

    this.clearMap(notClearMap);
  }

  clearMap(notClearMap=false) {
    //不清除地图选择绘制图层
    if(!notClearMap){
      super.clearMap();
    }

  }

  clearEvent() {
    super.clearEvent();
    if(this._finishEvent){
      this.map.off("contextmenu", this._finishEvent);
      this.map.off("dblclick", this._finishEvent);
    }

    //启用双击缩放
    if(this._doubleClickZoom){
      this.map.doubleClickZoom.enable()
    }

    if(this.selectControl){
      this.selectControl.close();
      this.selectControl=null;
    }
    this.clickLayers=[];
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/MergeTool.js